import React, { useState } from 'react';
import { Button } from '@ems/client-design-system';
// utils
import { detectIE } from 'src/@auth/functions/validation';
import { getUrlDetails } from 'src/@auth/functions/core';
// style
import './styles.scss';

const translationData = {
  welcome: 'Welcome to ANOMS',
  noSupported: 'Your web browser is not supported.',
  sessionExpired: 'Your session has expired.',
  missingSitename: 'Error: Site name not found',
  accessDenied: 'Access denied',
  failed: 'Failed to authenticate',
  sitename: 'Site Name',
  buttonText: 'Sign In',
  pleaseWait: 'Please Wait...',
  '000': 'You signed out of your account.',
  '001': "For your security, you've been signed out.",
  '404': 'The resource you are trying to access does not exist.',
  '403': 'You do not have permission to access the specified resource.',
};

export const StartScreen = ({ clickEvent, text = 'welcome', error = '', displayButton = true }) => {
  const [plzWait, updatePlzWait] = useState<boolean>(false);
  const { siteName } = getUrlDetails();
  const isIeEdge = detectIE() !== false;

  const greeting = () => {
    if (!isIeEdge) {
      if (siteName) {
        return (
          <>
            <div className="intro">
              {text && typeof translationData[text] !== 'undefined' && (
                <h2>{translationData[text]}</h2>
              )}
              {error && typeof translationData[error] !== 'undefined' && (
                <p className="sitename error">Error: {translationData[error]}</p>
              )}
            </div>
            {displayButton && (
              <div className="buttons">
                <Button
                  style="primary"
                  disabled={plzWait ? true : false}
                  aria-label={`Sign In`}
                  onClick={() => {
                    if (!plzWait) {
                      clickEvent();
                    }
                    updatePlzWait(true);
                  }}>
                  {plzWait ? translationData.pleaseWait : translationData.buttonText}
                </Button>
              </div>
            )}
          </>
        );
      } else {
        // sitename doesn't exist in the url
        return (
          <div className="intro">
            <h2>{translationData.welcome}</h2>
            <p className="sitename error">{translationData.missingSitename}</p>
          </div>
        );
      }
    } else {
      // IE and older Edge is not supported
      return (
        <div className="intro">
          <h2>{translationData.welcome}</h2>
          <p className="sitename error">{translationData.noSupported}</p>
        </div>
      );
    }
  };

  return (
    <div className="container">
      <div className="signin-wrapper" style={{ visibility: 'hidden', opacity: 0 }}>
        <div className="sign-in-box">
          <div className="logo" />
          {greeting()}
        </div>
      </div>
    </div>
  );
};
